<template lang="html">
  <transition name="modalanim">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <!-- Use minWidth so that the container is at least this wide but can grow -->
        <div class="modal-container" :style="{ minWidth: full_length, maxWidth: max_width }">
          <div class="modal-header">
            <h4 v-if="title != null" class="section_start">{{ title }}</h4>
          </div>

          <div class="modal-body">
            <slot>
              default body
            </slot>
          </div>

          <div class="modal-footer" v-show="!no_footer">
            <slot name="footer">
              <Btn
                :title="$txt.cancel"
                class="modal-default-button hol_btn"
                @clicked="$emit('close')"
              />
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ModalReports",
  props: {
    width: {
      default: 500, // This is now used as a minimum width
    },
    title: {
      default: null,
    },
    no_footer: {
      default: false,
    },
    max_width: {
      default: "75%",
    },
  },
  computed: {
    full_length() {
      return this.width.toString() + "px";
    },
  },

  methods: {
    handleKey(e) {
      if (e.key === "Enter") {
        e.preventDefault();
        const defaultEnterBtn = this.$el.querySelector('[data-default-enter]');
        if (defaultEnterBtn && typeof defaultEnterBtn.click === "function") {
          defaultEnterBtn.click();
        }
      } else if (e.key === "Escape") {
        e.preventDefault();
        const defaultEscBtn = this.$el.querySelector('[data-default-esc]');
        if (defaultEscBtn && typeof defaultEscBtn.click === "function") {
          defaultEscBtn.click();
        }
      } else if (e.key === "Backspace") {
        e.preventDefault();
        const defaultBackspaceBtn = this.$el.querySelector('[data-default-backspace]');
        if (defaultBackspaceBtn && typeof defaultBackspaceBtn.click === "function") {
          defaultBackspaceBtn.click();
        }
      }
    },
  },

  mounted() {
    window.addEventListener("keyup", this.handleKey);
  },
  beforeUnmount() {
    window.removeEventListener("keyup", this.handleKey);
  },
};
</script>

<style lang="css" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.1s ease;
}

.modal-wrapper {
  display: inherit;
  margin: auto;
  vertical-align: top;
  margin-top: 100px;
}

.modal-container {
  /* Remove fixed width so it can grow */
  /* width: 300px; */
  min-width: 300px; /* Fallback if width prop is not provided */
  margin: 0px auto;
  padding: 10px 10px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.1s ease;
  max-height: 80vh;
  overflow: hidden;          /* hide anything that spills out */
  width: auto;
}

.modal-header h3 {
  padding: 0px;
  margin-top: 0;
  color: #42b983;
}

.modal-header {
  padding: 0px;
}

.modal-body {
  padding: 5px;
  margin: 1px 0;
  /* max-height: 2000px;
  overflow-y: auto; */
  max-height: calc(75vh - /* header+footer total height */ 60px);
  overflow-y: auto;
}

.modal-footer {
  padding: 0px;
  padding-top: 0px;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 */

.modalanim-enter-active {
  transition: all 0.1s;
}

.modalanim-leave-active {
  transition: all 0.1s ease;
}

.modalanim-enter {
  opacity: 0 !important;
}

.modalanim-enter-to {
  opacity: 1 !important;
}

.modalanim-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>
